import React from "react";
import GreenStatusIcon from "../../../../../commons/icons/Status/greenStatusIcon";
import BlueStatusIcon from "../../../../../commons/icons/Status/blueStatusIcon";
import YellowStatusIcon from "../../../../../commons/icons/Status/yellowStatusIcon";
import RedStatusIcon from "../../../../../commons/icons/Status/redStatusIcon";
import GrayStatusIcon from "../../../../../commons/icons/Status/grayStatusIcon";

import { Container } from './styles';

export default ({ status }) => {

    function returnStatus() {
        switch (status) {
            case "ativo":
                return <><GreenStatusIcon style={{ marginRight: 6 }} /> {"Ativo"}</>
            case "aguardando_verificacao":
                return <><BlueStatusIcon style={{ marginRight: 6 }} /> {"Aguardando verificação"}</>
            case "temporario":
                return <><YellowStatusIcon style={{ marginRight: 6 }} /> {"Temporário"}</>
            case "bloqueado":
                return <><RedStatusIcon style={{ marginRight: 6 }} /> {"Bloqueado"}</>
            case "inativo":
                return <><GrayStatusIcon style={{ marginRight: 6 }} /> {"Inativo"}</>
        }
    }

    return (
        <Container>
            {returnStatus()}
        </Container>
    )
}